if (!top.RDX) {
    top.RDX = {};
}

export const setSelectedCannedReport = Id => ({
    type: "SET_SELECTED_CANNEDREPORT",
    Id,
});
top.RDX.setSelectedCannedReport = Id => top.store.dispatch(setSelectedCannedReport(Id));

export const clearSelectedCannedReport = () => ({
    type: "CLEAR_SELECTED_CANNEDREPORT",
});
top.RDX.clearSelectedCannedReport = () => top.store.dispatch(clearSelectedCannedReport());

export const setSelectedCannedColumn = column => ({
    type: "SET_SELECTED_CANNED_COLUMN",
    column,
});
export const clearSelectedCannedColumn = () => ({
    type: "CLEAR_SELECTED_CANNED_COLUMN",
});
export const setSelectedCannedColumns = column => ({
    type: "SET_SELECTED_CANNED_COLUMNS",
    column,
});
export const clearSelectedCannedColumns = () => ({
    type: "CLEAR_SELECTED_CANNED_COLUMNS",
});
